import React, { useState, useEffect } from 'react';
import { BASE_URL, IMG_URL } from '../config/api'; // Assuming BASE_URL is correctly defined
import { useNavigate, useParams } from 'react-router-dom';

const ViewVisit = () => {
    const [visit, setVisit] = useState(null);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();
    const { id } = useParams(); // Fetch the visit ID from the URL

    // Fetch visit data when the component is mounted
    useEffect(() => {
        fetch(`${BASE_URL}visits/${id}`)
            .then(response => response.json())
            .then(data => {
                if (data.status === 1) {
                    setVisit(data.data);
                    setLoading(false);
                } else {
                    alert('Failed to fetch visit data');
                }
            })
            .catch(error => {
                console.error('Error fetching visit data:', error);
                alert('Error fetching visit data');
            });
    }, [id]);

    if (loading) {
        return <div>Loading...</div>;
    }

    return (
        <div id="main">
            <header className="mb-3">
                <a href="#" className="burger-btn d-block d-xl-none">
                    <i className="bi bi-justify fs-3"></i>
                </a>
            </header>

            <div className="page-heading">
                <div className="page-title">
                    <div className="row">
                        <div className="col-12 col-md-6 order-md-1 order-last">
                            <h3>View Visit</h3>
                        </div>
                    </div>
                </div>
            </div>

            <section className="section">
                <div className="row">
                    <div className="col-12 col-md-12">
                        <div className="card">
                            <div className="card-header">
                                <h4 className="card-title">Visit Details</h4>
                            </div>
                            <div className="card-body">
                                {/* Display Visit Data */}
                                <div className="mb-3">
                                    <label className="form-label">Customer Name</label>
                                    <p>{visit.customer_name}</p>
                                </div>

                                <div className="mb-3">
                                    <label className="form-label">Contact Person Name</label>
                                    <p>{visit.contact_person_name}</p>
                                </div>

                                <div className="mb-3">
                                    <label className="form-label">Contact Number</label>
                                    <p>{visit.contact_number}</p>
                                </div>

                                <div className="mb-3">
                                    <label className="form-label">Description</label>
                                    <p>{visit.description}</p>
                                </div>

                                {/* Display Visiting Card Image */}
                                {visit.visiting_card_image && (
                                    <div className="mb-3">
                                        <label className="form-label">Visiting Card</label>
                                        <div>
                                            <img
                                                src={IMG_URL + visit.visiting_card_image}
                                                alt="Visiting Card"
                                                style={{ width: '150px', height: 'auto' }}
                                            />
                                        </div>
                                    </div>
                                )}

                                {/* Back Button */}
                                <div className="text-end">
                                    <button
                                        className="btn btn-secondary"
                                        onClick={() => navigate('/VisitsList')}
                                    >
                                        Back to Visit List
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default ViewVisit;
